<div class="modal-dialog modal-m">
  <!-- Modal content-->
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="close pull-right" aria-label="Close" (click)="logoutFormTheSystem()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title">Session Expiary</h4>
    </div>
    <div class="modal-body">
      <p>Your session has expired, please re-login to renew your session.</p>
    </div>
    <div class="modal-footer">
      <a (click)="logoutFormTheSystem()">
        <button type="button" class="btn btn-primary btn-flat">Ok</button>
      </a>
    </div>
  </div>
</div>